import BaseService from '@/ecm/common/BaseService.js'
import Utils from '@/ecm/common/Utils.js'

class DigitalSignatureService {
  baseUrl = 'digital-signature';

  getGrid = () => Utils.grid.getParameters(`${this.baseUrl}/get-grid`);
  getList = () => BaseService.get({ url: `${this.baseUrl}/get-list` });
  getProviderList = () => BaseService.get({ url: `${this.baseUrl}/get-provider-list` });
  getSignatureImage = (id) => BaseService.get({ url: `${this.baseUrl}/get-signature-img/${id}` });
  delete = (id) => BaseService.post({ url: `${this.baseUrl}/delete/${id}` });
  save = (digitalSignature) => BaseService.post({ url: `${this.baseUrl}/save`, data: digitalSignature });
}

export default new DigitalSignatureService()
